module.exports = __webpack_public_path__ + "static/media/waiter.be2e5917.png";